import { Injectable, NgZone } from "@angular/core";
import { AuthService } from "./auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private timeoutId: any;
  private readonly inactivityTime = 20 * 60 * 1000;

  constructor(
    private readonly ngZone: NgZone,
    private readonly authService: AuthService,
  ) { }

  public setupActivityListeners() {
    ['mousemove', 'keydown', 'click', 'touchstart', 'touchmove'].forEach(event => {
      window.addEventListener(event, () => this.resetTimer());
    });
    this.resetTimer();
  }

  private resetTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.signOut(), this.inactivityTime);
    });
  }

  private signOut() {
    this.authService._manager.signoutSilent();
  }
}
